import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CreateCustomerOrderComponent } from './create-customer-order/create-customer-order.component';
import { CustomerOrderListComponent } from './customer-order-list/customer-order-list.component';
import { InventoryComponent } from './inventory/inventory.component';

const routes: Routes = [
  { path: 'create-customer-order', component: CreateCustomerOrderComponent },
  { path: 'customer-order-list', component: CustomerOrderListComponent },
  { path: 'inventory', component: InventoryComponent },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class EStampRoutingModule { }
